import {
  Box,
  IconButton,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material';
import moment from 'moment';
import { Link } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { ISMS } from '../../Types/DashvoardHomeType';

interface IProps {
  index: number;
  sNotice: ISMS;
}
const SMSTableRow = ({ sNotice, index }: IProps) => {
  const theme = useTheme();

  return (
    <>
      <TableRow hover>
        <TableCell>{index + 1}</TableCell>
        <TableCell>
          <Typography
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              textAlign: 'justify',
            }}
          >
            {sNotice?.text}
          </Typography>
        </TableCell>
        <TableCell>
          {moment(sNotice.created_at)?.format('MMMM Do YYYY, h:mm a')}
        </TableCell>

        {/* <TableCell>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box>
              <Link to={``}>
                <Tooltip title='view' arrow>
                  <IconButton
                    sx={{
                      '&:hover': {
                        background: theme.colors.primary.lighter,
                      },
                      color: theme.palette.primary.main,
                    }}
                    color='inherit'
                    size='small'
                  >
                    <VisibilityIcon fontSize='small' />
                  </IconButton>
                </Tooltip>
              </Link>
            </Box>
          </Box>
        </TableCell> */}
      </TableRow>
    </>
  );
};

export default SMSTableRow;
